import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { PayrollGroupRequest } from '../payrollGroup.types';

const useCreatePayrollGroupQuery = (onSuccess?: () => void) => {
  const { mutateAsync, isLoading } = useMutation(
    (newGroup?: PayrollGroupRequest) => api.post(API_URL.PAYROLL_GROUPS, newGroup),
    {
      onSuccess: () => {
        if (onSuccess) onSuccess();
      },
    }
  );

  const save = useCallback(
    async (newGroup?: PayrollGroupRequest) => {
      await mutateAsync(newGroup);
    },
    [mutateAsync]
  );

  return {
    save,
    isLoading,
  };
};

export default useCreatePayrollGroupQuery;
